import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=56b5d57f&scoped=true"
import script from "./SchoolList.vue?vue&type=script&lang=js"
export * from "./SchoolList.vue?vue&type=script&lang=js"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=56b5d57f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5d57f",
  null
  
)

export default component.exports